import React, { useState } from "react";
import { api } from "@/lib/api";
import { Eye, X, ExternalLink, ChevronUp } from "lucide-react";

const COTIZAR_URL = "https://instabio.cc/Uaicardmx2026";

export default function DemoBanner() {
  const isDemo = (() => { try { return sessionStorage.getItem("uaicard_demo") === "1"; } catch { return false; } })();
  const [hidden, setHidden] = useState(false);
  // Recuerda si el usuario lo dejó minimizado/expandido durante la sesión (no se reabre en cada pantalla).
  const [open, setOpen] = useState(() => { try { return sessionStorage.getItem("uaicard_demo_open") === "1"; } catch { return false; } });
  if (!isDemo || hidden) return null;

  const setOpenPersist = (v) => {
    setOpen(v);
    try { sessionStorage.setItem("uaicard_demo_open", v ? "1" : "0"); } catch { /* noop */ }
  };

  const exitDemo = async () => {
    try { sessionStorage.removeItem("uaicard_demo"); } catch { /* noop */ }
    try { localStorage.removeItem("uaicard_parent_token"); } catch { /* noop */ }
    try { await api.post("/auth/logout"); } catch { /* noop */ }
    window.location.href = "/";
  };

  // Chip discreto arriba al centro (debajo del header). No tapa el menú inferior ni las áreas.
  return (
    <div className="fixed top-[70px] md:top-3 left-1/2 -translate-x-1/2 z-[55] max-w-[94vw]" data-testid="demo-banner">
      {open ? (
        <div className="flex items-center gap-2 bg-navy/95 backdrop-blur text-white rounded-full shadow-xl border border-amber-300/40 pl-2.5 pr-1.5 py-1.5 animate-slide-up">
          <span className="w-6 h-6 rounded-full bg-amber-300 text-navy flex items-center justify-center shrink-0">
            <Eye className="w-3.5 h-3.5" />
          </span>
          <span className="text-[11px] font-medium text-nardo-100 whitespace-nowrap hidden sm:inline">Modo demostración · datos de muestra</span>
          <span className="text-[11px] font-medium text-nardo-100 whitespace-nowrap sm:hidden">Modo demo</span>
          <a
            href={COTIZAR_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="demo-quote-button"
            className="shrink-0 inline-flex items-center gap-1 bg-amber-300 hover:bg-amber-400 text-navy font-semibold text-[11px] px-2.5 py-1 rounded-full transition-colors"
          >
            Cotizar <ExternalLink className="w-3 h-3" />
          </a>
          <button onClick={() => setOpenPersist(false)} data-testid="demo-collapse-button" title="Minimizar" className="shrink-0 text-white/70 hover:text-white p-1">
            <ChevronUp className="w-3.5 h-3.5" />
          </button>
          <button onClick={exitDemo} data-testid="demo-exit-button" title="Salir de la demo" className="shrink-0 text-white/70 hover:text-white p-1">
            <X className="w-3.5 h-3.5" />
          </button>
        </div>
      ) : (
        <button
          onClick={() => setOpenPersist(true)}
          data-testid="demo-chip"
          title="Modo demostración"
          className="inline-flex items-center gap-1.5 bg-navy/90 backdrop-blur text-white rounded-full shadow-lg border border-amber-300/40 pl-2 pr-3 py-1 text-[11px] font-semibold hover:bg-navy transition-colors"
        >
          <span className="w-5 h-5 rounded-full bg-amber-300 text-navy flex items-center justify-center shrink-0">
            <Eye className="w-3 h-3" />
          </span>
          Demo
        </button>
      )}
    </div>
  );
}
